var React = require('react');

function MarkerLocal (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M.016 11.59C.016 5.198 5.215 0 11.605 0c6.39 0 11.589 5.199 11.589 11.59 0 7.93-10.371 19.572-10.813 20.064a1.044 1.044 0 01-1.553 0C10.387 31.162.016 19.52.016 11.589zm5.758 0a5.837 5.837 0 005.83 5.83 5.837 5.837 0 005.832-5.83 5.837 5.837 0 00-5.831-5.832 5.837 5.837 0 00-5.83 5.831z","fill":"#fff"}));
}

MarkerLocal.defaultProps = {"width":"24","height":"32","viewBox":"0 0 24 32","fill":"none"};

module.exports = MarkerLocal;

MarkerLocal.default = MarkerLocal;
